// Time / date helpers for Chronicles. All times are 24h.

import { getLocale } from "@/i18n/locale";

export const MIN_PER_DAY = 24 * 60;

export function pad2(n) {
  return String(n).padStart(2, "0");
}

export function toMinutes(h, m) {
  return Number(h) * 60 + Number(m);
}

export function formatHM(h, m) {
  return `${pad2(h)}:${pad2(m)}`;
}

export function formatRange(ev) {
  return `${formatHM(ev.startHour, ev.startMinute)} – ${formatHM(ev.endHour, ev.endMinute)}`;
}

export function todayISO() {
  const d = new Date();
  return toISODate(d);
}

export function toISODate(d) {
  const y = d.getFullYear();
  const m = pad2(d.getMonth() + 1);
  const day = pad2(d.getDate());
  return `${y}-${m}-${day}`;
}

export function addDaysISO(iso, delta) {
  const d = parseISODate(iso);
  d.setDate(d.getDate() + delta);
  return toISODate(d);
}

export function parseISODate(iso) {
  // iso = YYYY-MM-DD — interpret as local date (avoid UTC drift)
  if (!iso) return new Date();
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, (m || 1) - 1, d || 1);
}

export function formatLongDate(iso) {
  return new Intl.DateTimeFormat(getLocale(), {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(parseISODate(iso));
}

export function formatShortDate(iso) {
  return new Intl.DateTimeFormat(getLocale(), {
    weekday: "short",
    day: "numeric",
    month: "short",
  }).format(parseISODate(iso));
}

export function isToday(iso) {
  return iso === todayISO();
}
